import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
// import { Menu, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from "@mui/icons-material/Create";
import DescriptionIcon from "@mui/icons-material/Description";
import { isIOS } from "react-device-detect";

class WidgetOptionsMenu extends React.Component {
  exportToCSV = () => {
    this.props.handleCSVExport();
    this.props.handleOptionsMenuClose();
  };

  render = () => {
    const open = Boolean(this.props.anchorEl);

    return <Menu
      id="widget-options-menu"
      anchorEl={this.props.anchorEl}
      open={open}
      aria-hidden={!open}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={this.props.handleOptionsMenuClose}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <MenuItem onClick={this.props.handleWidgetDeleteConfirmDialog}>
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        <ListItemText primary="Delete this Widget" />
      </MenuItem>
      <MenuItem onClick={this.props.editWidgetTitle}>
        <ListItemIcon>
          <CreateIcon />
        </ListItemIcon>
        <ListItemText
          primary={(this.props.hasTitle ? "Rename" : "Name") + " this Widget"}
        />
      </MenuItem>
      {!isIOS && this.props.handleCSVExport && (
        <MenuItem onClick={this.exportToCSV}>
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText primary="Export to CSV" />
        </MenuItem>
      )}
    </Menu>
  };
}

export default WidgetOptionsMenu;
